import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Http, Response, Headers, RequestOptions, RequestMethod } from '@angular/http';

@Injectable()
export class ApiService {
    constructor (private http: Http) {}
    
    /**
     * Get Method to get data from Api Endpoint
     * @param requestUrl - string
     * @return Observable<Type>
     */
    get<T>(requestUrl: string): Observable<T> {
        const options = new RequestOptions({ withCredentials: true });
        return this.http.get(requestUrl, options)
                   .map(this.extractData)
                   .catch(this.handleError);
    }

    /**
     * Get Method to get data from Api Endpoint - Use to export pdf
     * @param requestUrl - string
     * @return Observable<Type>
     */
    getFile(requestUrl: string): Observable<Blob> {
        const options = new RequestOptions({
            withCredentials: true,
        });
        return this.http.get(requestUrl, options)
                    .map((response) => {
                        let body = JSON.parse(response['_body']);
                        return body.buffer.data;
                    })
                    .catch(this.handleError);
    }

    /**
     * Post Method to post data from Api Endpoint
     * @param requestUrl - string
     * @return Observable<Type>
     */
    post<T>(requestUrl: string, data: any): Observable<T> {
        let headers: Headers;

        if(!(data instanceof FormData)) {
            headers = new Headers({'Content-Type': 'application/json'}); 
        }
        
        const options = new RequestOptions({
                            headers: headers,
                            withCredentials: true
                        });

        return this.http.post(requestUrl, data, options)
                        .map(this.extractData)
                        .catch(this.handleError);
    }

    /**
     * Put Method to post data to Api Endpoint
     * @param requestUrl - string
     * @return Observable<Type>
     */
    put<T>(requestUrl: string, data: any): Observable<T> {
        let headers: Headers;

        if(!(data instanceof FormData)) {
            headers = new Headers({'Content-Type': 'application/json'}); 
        }
        
        const options = new RequestOptions({
                            headers: headers,
                            withCredentials: true
                        });

        return this.http.put(requestUrl, data, options)
                        .map(this.extractData)
                        .catch(this.handleError);
    }

    /**
     * Patch Method to update data through Api Endpoint
     * @param requestUrl: string
     * @return Observable<Type>
     */
    patch<T>(requestUrl: string, data: any): Observable<T> {
        let headers: Headers;

        if(!(data instanceof FormData)) {
            headers = new Headers({'Content-Type': 'application/json'});
        }

        const options = new RequestOptions({ 
                            method: RequestMethod.Patch,
                            headers: headers,
                            withCredentials: true
                        });
        
        return this.http.patch(requestUrl, data, options)
                        .map(this.extractData)
                        .catch(this.handleError);
    }

    /**
     * Delete Method to remove the data through Api Endpoint
     * @param requestUrl: string
     * @return Observable<Type>
     */
    delete(requestUrl: string) {
        const options = new RequestOptions({ withCredentials: true });

        return this.http.delete(requestUrl, options)
                        .catch(this.handleError);
    }

    /**
     * Delete Method to remove the data through Api Endpoint
     * @param requestUrl: string
     * @return Observable<Type>
     */
    deletePost<T>(requestUrl: string, data: any): Observable<T> {
         let headers: Headers;

        if(!(data instanceof FormData)) {
            headers = new Headers({'Content-Type': 'application/json'});
        }

        const options = new RequestOptions({ 
                            method: RequestMethod.Delete,
                            headers: headers,
                            withCredentials: true
                        });
        
        return this.http.post(requestUrl, data, options)
                        .map(this.extractData)
                        .catch(this.handleError);
    }

    /**
     * Extract Response data from Request Response
     * @param res: Response
     * @return JSON data
     */
    private extractData (res: Response) {
        let body: any;
        let contentType = res.headers.get("content-type");

        // If response has content type "application/json"
        // then parse the body
        if(contentType && contentType.indexOf('application/json') !== -1) {
            try {
                body = res.json();
            }
            catch(error) {
                body = { };
            }
        }
        // Otherwise return body as text
        else {
            body = res.text();
        }

        return body;
    }

    /**
     * Handle Error returned from Request Response
     * @param error: any
     * @return Observable<error>
     */
    private handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        // console.log(errMsg); // log to console instead
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/core/services/ApiService.ts